import Container from '@/components/ui/container';
import Logo from './logo';

import SearchBox from './search';
import UserActions from './user-actions';
import ShippingAddress from './ShippingAddress';
import AddToWishlist from '@/components/ui/buttons/add-to-wishlist';
import SideMenuButton from '@/components/ui/buttons/side-menu-button';

const MainHeader = () => {
  return (
    <nav className='lg:border-b-tertiary-300 max-sm:py-1 lg:border-b'>
      <Container className='border-b-tertiary-300 flex h-[51px] items-center justify-between gap-1.5 border-b py-0! max-lg:flex-wrap max-sm:py-0 sm:h-19 sm:gap-4 md:h-20 lg:h-21 lg:gap-7.5 lg:border-b-0'>
        <div className='hidden lg:block'>
          <Logo />
        </div>
        <ShippingAddress />

        <div className='hidden flex-1 items-center gap-5 max-lg:justify-end max-sm:order-last max-sm:basis-full lg:flex lg:h-11'>
          <input id='tw-search' type='checkbox' className='peer hidden' />
          <label
            htmlFor='tw-search'
            className='flex-1 peer-checked:flex max-lg:basis-full'
          >
            <SearchBox />
          </label>
        </div>

        <div className='relative ms-auto flex items-center gap-4 lg:hidden'>
          <div className='hidden lg:block'>
            <AddToWishlist />
          </div>
          <SideMenuButton />
        </div>

        <UserActions />
      </Container>
      <Container>
        <div className='flex w-full items-center justify-between gap-3 bg-white md:gap-[25px] lg:hidden'>
          <div className='hidden sm:block'>
            <Logo />
          </div>
          <div className='sm:hidden'>
            <Logo fromMobile />
          </div>
          <SearchBox />
        </div>
      </Container>
    </nav>
  );
};

export default MainHeader;
